import { FORM_REPLACE } from '../constants/actionTypes';

export const replaceFormState = state => ({
	type: FORM_REPLACE,
	payload: {
		state,
	},
});



// WEBPACK FOOTER //
// ./src/actions/form.js